import { signOut } from "firebase/auth";
import { auth } from "../../../firebase";

/**
 * Signs out the current user using Firebase authentication.
 * @param {function} onSignOutSuccess - Callback function to execute after successful signout.
 * @returns {Promise<void>} A promise that resolves when signout is complete.
 */
export async function handleSignOut(onSignOutSuccess) {
  try {
    await signOut(auth);
    console.log("User signed out successfully.");
    if (onSignOutSuccess) {
      onSignOutSuccess();
    }
  } catch (error) {
    console.error("Error signing out:", error);
    throw error;
  }
}
